import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
  HttpResponse,
  HttpEventType,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ApiService } from '../common/api.service';
import { ROUTES } from '../server-route';
import { RequestMapper } from '../../request-mapper';
import { AuthService } from '../auth/auth-service';
import { ToastrService } from 'ngx-toastr';
import * as CryptoJS from 'crypto-js';
import { environment } from '../../../environments/environment';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class InterceptorsService implements HttpInterceptor {
  constructor(
    private apiService: ApiService,
    private authService: AuthService,
    private router: Router,
    private toaster: ToastrService
  ) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const modifiedRequest = req.clone({
      responseType: 'text' // Ensure all responses are received as text
    });

    return next.handle(modifiedRequest).pipe(
      map((event: HttpEvent<any>) => {
        if (event.type === HttpEventType.Response) {
          const response: HttpResponse<any> = event as HttpResponse<any>;
          const responseBody = response.body;
          try {
            let parsedBody = JSON.parse(responseBody);
            if (typeof parsedBody === 'object' && parsedBody !== null) {
              return response.clone({ body: parsedBody });
            }
          } catch {
          }
          try {
            const decryptedBody = this.decryptData(responseBody);
            return response.clone({ body: decryptedBody });
          } catch (decryptionError) {
            return response;
          }
        }
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        console.log(error)
        let decryptedError = error.error;
        try {
          decryptedError = JSON.parse(decryptedError);
        } catch {
          decryptedError = this.decryptData(error.error);
        }
        if (error.status === 401) {
          this.authService.logOut();
          return throwError(() => decryptedError);
        } else if (error.status === 403) {

          this.router.navigate([`/${RequestMapper.UNAUTHORIZED_ACCESS}`]);
          return throwError(() => decryptedError);
        } else if (error.status === 502) {
          this.authService.logOut();
          this.toaster.error("DP Global - server's are under maintenance. Please try again after sometime !");
          return throwError(() => error)
        }
        return throwError(() => decryptedError);
      })
    )
  }
  private refreshToken() {
    this.authService.clearTimer();
    const refreshToken = localStorage.getItem('AccessToken');
    if (!refreshToken) {
      this.router.navigate(['/login']);
      // return throwError(() => 'No refresh token available');
    }
    // return this.apiService
    //   .get<{ accessToken: string }>(ROUTES.REFRESH_TOKEN)
    //   .pipe(
    //     map((response: any) => {
    //       this.authService.storeJwtTokenInLocalStorage(response.data);
    //       return response.data.accessToken;
    //     }),
    //     catchError((error) => {
    //       this.authService.logOut();
    //       return throwError(() => error);
    //     })
    //   );
  }

  // private encryptData(data: any): string {
  //   try {
  //     const key = environment.encryptionKey;
  //     const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), key);
  //     return encrypted.toString();
  //   } catch (error) {
  //     return '';
  //   }
  // }

  private reverseModification(modifiedEncrypted: string) {
    const cleanedEncrypted =
      modifiedEncrypted.slice(0, 8) + modifiedEncrypted.slice(11);
    return cleanedEncrypted;
  }

  private decryptData(encryptedData: any): any {
    try {
      let key = environment.encryptionKey;
      let decryptedBytes = CryptoJS.AES.decrypt(
        this.reverseModification(encryptedData),
        key
      ).toString(CryptoJS.enc.Utf8);
      let decryptedBody = JSON.parse(decryptedBytes);
      return decryptedBody;
    } catch (error) {
      return null;
    }
  }

  // private encryptData(data: any): string {
  //   try {
  //     const key = environment.encryptionKey;
  //     const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), key);
  //     return encrypted.toString();
  //   } catch (error) {
  //     return '';
  //   }
  // }


}
